import cn from 'classnames';
import Input from './components/Input/Input.css';
import Checkin from './components/Checkin/Checkin.css';
import Results from './components/Results/Results.css';
import SegmentTabs from './components/SegmentTabs/SegmentTabs.css';
import SegmentTab from './components/SegmentTabs/SegmentTab/SegmentTab.css';
import SeatMap from './components/SeatMap/SeatMap.css';
import SeatMapAirplane from './components/SeatMap/Airplane/Airplane.css';
import SeatMapPassengers from './components/SeatMap/Passengers/Passengers.css';
import SeatMapPassenger from './components/SeatMap/Passenger/Passenger.css';
import SeatMapDoubleSeat from './components/SeatMap/DoubleSeat/DoubleSeat.css';
import SeatMapDisclaimer from './components/SeatMap/Disclaimer/Disclaimer.css';
import SeatMapControls from './components/SeatMap/Controls/Controls.css';
import SeatMapSeat from './components/SeatMap/Seat/Seat.css';
import SeatMapSeatsInfo from './components/SeatMap/SeatsInfo/SeatsInfo.css';
import SeatMapTooltip from './components/SeatMap/Tooltip/Tooltip.css';
import AdditionalServiceBanner from './components/AdditionalServiceBanner/AdditionalServiceBanner.css';
import BaggagePage from './components/BaggagePage/BaggagePage.css';
import BaggageList from './components/BaggageList/BaggageList.css';
import BaggageCount from './components/BaggageList/BaggageCount/BaggageCount.css';
import BaggageDirection from './components/BaggageList/BaggageDirection/BaggageDirection.css';
import Baggage from './components/Baggage/Baggage.css';
import BaggageIcon from './components/Baggage/BaggageIcon/BaggageIcon.css';
import AdditionalPromoMessage from './components/AdditionalBaggage/PromoMessage/PromoMessage.css';
import BaggageCard from './components/BaggageCard/BaggageCard.css';
import UpgradeBaggageDialog from './components/UpgradeBaggageDialog/UpgradeBaggageDialog.css';
import BaggageDialogHeader from './components/UpgradeBaggageDialog/BaggageDialogHeader/BaggageDialogHeader.css';
import BaggagePassenger from './components/UpgradeBaggageDialog/BaggagePassenger/BaggagePassenger.css';
import BaggageSegment from './components/UpgradeBaggageDialog/BaggageSegment/BaggageSegment.css';
import BaggageFooter from './components/UpgradeBaggageDialog/BaggageFooter/BaggageFooter.css';
import BaggageCounter from './components/BaggageCounter/BaggageCounter.css';
import Counter from './components/Counter/Counter.css';
import SwitchV2 from './components/Switch/SwitchV2/SwitchV2.css';
import MealServiceList from './components/MealService/List/List.css';
import Meal from './components/Meal/Meal.css';
import MealDetails from './components/Meal/Details/Details.css';
import ActionButton from './components/Button/ActionButton/ActionButton.css';
import DesktopSummaryFlight from './components/DesktopSummaryFlight/DesktopSummaryFlight.css';
import Checkout from './components/Checkout/Checkout.css';
import Contacts from './components/Contacts/Contacts.css';
import PassengerForm from './components/PassengerForm/PassengerForm.css';
import PassengerFormHeader from './components/PassengerForm/Header/Header.css';
import PassengerFormGroup from './components/PassengerForm/Group/Group.css';
import PassengerFormLoyaltyGroup from './components/PassengerForm/LoyaltyGroup/LoyaltyGroup.css';
import ServiceRecommendation from './components/ServiceRecommendation/ServiceRecommendation.css';
import PassengerSwitch from './components/Passenger/Switch/Switch.css';
import OrderCard from './components/OrderCard/OrderCard.css';
import OrderPreview from './components/OrderCard/OrderPreview/OrderPreview.css';
import CommonItem from './components/OrderCard/CommonItem/CommonItem.css';
import PaymentStatus from './components/OrderCard/PaymentStatus/PaymentStatus.css';
import OrderBooking from './components/OrderCard/OrderBooking/OrderBooking.css';
import OrderChange from './components/OrderCard/OrderChange/OrderChange.css';
import CheckoutAdditionalServiceBusiness from './components/CheckoutAdditionalService/Business/Business.css';
import Aeroexpress from './components/Aeroexpress/Aeroexpress.css';
import AeroexpressModalContent from './components/Aeroexpress/ModalContent/ModalContent.css';
import Insurance from './components/Insurance/Insurance.css';
import InsuranceCard from './components/Insurance/InsuranceCard/InsuranceCard.css';
import InsuranceCardMobileScreen from './components/Insurance/MobileScreen/MobileScreen.css';
import VipServiceSelect from './components/VipServiceSelect/VipServiceSelect.css';
import Toolbar from './components/Toolbar/Toolbar.css';
import SearchFormSegments from './components/SearchForm/Segments/Segments.css';
import SearchFormSegment from './components/SearchForm/Segment/Segment.css';
import SearchFormLocation from './components/SearchForm/Location/Location.css';
import SearchFormValue from './components/SearchForm/Value/Value.css';
import SearchFormDatepicker from './components/SearchForm/Datepicker/Datepicker.css';
import SearchFormControls from './components/SearchForm/Controls/Controls.css';
import SearchFormPassengers from './components/SearchForm/Passengers/Passengers.css';
import SearchFormCurrency from './components/SearchForm/Currency/Currency.css';
import SearchFormStartSearch from './components/SearchForm/StartSearch/StartSearch.css';
import SearchFormBottom from './components/SearchForm/Bottom/Bottom.css';
import SearchFormMultiCity from './components/SearchForm/MultiCity/MultiCity.css';
import LocationDropdown from './components/LocationAutocomplete/Dropdown/Dropdown.css';
import LocationGroup from './components/LocationAutocomplete/Group/Group.css';
import LocationOption from './components/LocationAutocomplete/Option/Option.css';
import DirectionsDialog from './components/LocationAutocomplete/DirectionsDialog/DirectionsDialog.css';
import SearchFormDatepickerMonthHeader from './components/SearchFormDatepicker/MonthHeader/MonthHeader.css';
import SearchFormDatepickerMonthsWrapper from './components/SearchFormDatepicker/MonthsWrapper/MonthsWrapper.css';
import SearchFormDatepickerWeeklyHeader from './components/SearchFormDatepicker/WeeklyHeader/WeeklyHeader.css';
import SearchFormDatepickerDay from './components/SearchFormDatepicker/Day/Day.css';
import ResultsCalendar from './components/Results/Calendar/Calendar.css';
import ResultsSortings from './components/Results/Sortings/Sortings.css';
import ResultsFlightsList from './components/Results/FlightsList/FlightsList.css';
import ResultsMobilePriceGraph from './components/Results/MobilePriceGraph/MobilePriceGraph.css';
import QuickSearchForm from './components/QuickSearchForm/QuickSearchForm.css';
import QuickSearchFormSummary from './components/QuickSearchForm/Summary/Summary.css';
import StepbarStep from './components/Stepbar/Step/Step.css';
import WeekCalendar from './components/WeekCalendar/WeekCalendar.css';
import WeekCalendarSlider from './components/WeekCalendar/Slider/Slider.css';
import WeekCalenderDay from './components/WeekCalendar/Day/Day.css';
import DesktopFlightRoute from './components/DesktopFlightRoute/DesktopFlightRoute.css';
import DesktopFlightRouteSegment from './components/DesktopFlightRoute/Segment/Segment.css';
import DesktopFlightRoutePoint from './components/DesktopFlightRoute/Point/Point.css';
import DesktopFlightRouteArrow from './components/DesktopFlightRoute/RouteArrow/RouteArrow.css';
import DesktopFlightRoutePrice from './components/DesktopFlightRoute/FlightPrice/FlightPrice.css';
import DesktopFlightRouteStopsInfo from './components/DesktopFlightRoute/StopsInfo/StopsInfo.css';
import MobileFlight from './components/MobileFlight/MobileFlight.css';
import PassengersPassenger from './components/Passengers/Passenger/Passenger.css';
import DesktopFlightHeader from './components/DesktopFlight/Header/Header.css';
import DesktopFlightModalContent from './components/DesktopFlight/ModalContent/ModalContent.css';
import DesktopFlightLocation from './components/DesktopFlight/Location/Location.css';
import DesktopFlightSelectedFare from './components/DesktopFlight/SelectedFareGroup/SelectedFareGroup.css';
import DesktopFlightFlightInfoSegment from './components/DesktopFlight/FlightInfoSegment/FlightInfoSegment.css';
import FareGroup from './components/FareGroup/FareGroup.css';
import FareGroupGrid from './components/FareGroup/FareGroupGrid/FareGroupGrid.css';
import FareGroupIcon from './components/FareGroup/FareGroupIcon/FareGroupIcon.css';
import FlightCard from './components/FlightCard/FlightCard.css';
import FareLock from './components/FareLock/FareLock.css';
import FareLockDescriptionBlock from './components/FareLock/DescriptionBlock/DescriptionBlock.css';
import FareLockSwitchBlock from './components/FareLock/SwitchBlock/SwitchBlock.css';
import DatepickerDay from './components/Datepicker/Day/Day.css';
import Amenities from './components/Amenities/Amenities.css';
import Link from './components/Link/Link.css';
import PassengersDetails from './components/PassengersDetails/PassengersDetails.css';
import HeaderEquipmentItem from './components/UpgradeBaggageDialog/HeaderEquipmentItem/HeaderEquipmentItem.css';
import PromoLoader from './components/PromoLoader/PromoLoader.css';
import StepsButtons from './components/Refund/StepsButtons/StepsButtons.css';
import Ticket from './components/Refund/Ticket/Ticket.css';
import PaymentForm from './components/PaymentForm/PaymentForm.css';
import PriceGraph from './components/PriceGraph/PriceGraph.css';
import CompareFares from './components/CompareFares/CompareFares.css';
import Pagination from './components/Pagination/Pagination.css';
import SearchForm from './components/SearchForm/SearchForm/SearchForm.css';
const theme = {
    Input: {
        Input: {
            input: Input.input,
            input_standard: Input.input_standard,
            real_input: Input.real_input,
            input_focused: Input.input_focused,
            underline: Input.underline
        }
    },
    RetrieveBooking: {
        RetrieveBooking: {
            checkinHint: Checkin.retrieveBooking__checkinHint
        }
    },
    Segment: {
        SegmentCommon: {
            wrapper: Checkin.segmentCommon__wrapper,
            city__airport: Checkin.segmentCommon__cityAirport,
            flightInfo__title: Checkin.segmentCommon__flightInfoTitle,
            plane__icon: Checkin.segmentCommon__planeIcon,
            header: Checkin.segmentCommon__header
        }
    },
    StatusMessage: {
        StatusMessage: {
            statusMessage: Checkin.statusMessage,
            statusMessage_success: Checkin.statusMessage_success
        }
    },
    RegisteredPassenger: {
        RegisteredPassenger: {
            header: Checkin.registeredPassenger__header,
            seats__icon: Checkin.registeredPassenger__seatsIcon,
            footerActions: Checkin.registeredPassenger__footerActions,
            downloadButton: Checkin.registeredPassenger__downloadButton,
            downloadIcon: Checkin.registeredPassenger__downloadIcon
        },
        SendToEmail: {
            text: Checkin.registeredPassenger__sendToEmailText
        },
        Service: {
            service: Checkin.registeredPassenger__service,
            service__icon: Checkin.registeredPassenger__serviceIcon,
            service__name: Checkin.registeredPassenger__serviceName,
            service__info: Checkin.registeredPassenger__serviceInfo
        }
    },
    AddPassenger: {
        AddPassenger: {
            passengerIcon: Checkin.addPassenger__passengerIcon,
            form__input: Checkin.addPassenger__formInput
        }
    },
    MobileSegment: {
        MobileSegment: {
            wrapper: Checkin.mobileSegment__wrapper
        }
    },
    SegmentTabs: {
        SegmentTabs: {
            inner: SegmentTabs.inner,
            title: SegmentTabs.title
        },
        SegmentTab: {
            segment: SegmentTab.segment,
            segment_active: SegmentTab.segment_active,
            checked: SegmentTab.checked
        }
    },
    SeatMap: {
        SeatMapStyles: {
            wings: SeatMap.wings,
            row__serviceHeader: SeatMap.row__serviceHeader,
            row__serviceHeader__wrapper: SeatMap.row__serviceHeader__wrapper,
            row__serviceHeader__serviceName: SeatMap.row__serviceHeader__serviceName
        },
        AirplaneStyles: {
            airplane: SeatMapAirplane.airplane,
            airplane__name: SeatMapAirplane.airplane__name,
            details: SeatMapAirplane.details
        },
        AirplaneInfoStyles: {
            sunInfo: SeatMapAirplane.sunInfo
        },
        PassengersStyles: {
            together: SeatMapPassengers.together,
            recommend: SeatMapPassengers.recommend,
            recommend__wrapper: SeatMapPassengers.recommend__wrapper,
            recommend__label: SeatMapPassengers.recommend__label,
            recommend__price: SeatMapPassengers.recommend__price,
            recommend__icon: SeatMapPassengers.recommend__icon,
            passengers__button: SeatMapPassengers.passengers__button,
            passengers__button_clear: SeatMapPassengers.passengers__button_clear
        },
        Passenger: {
            item: SeatMapPassenger.item,
            item_active: SeatMapPassenger.item_active,
            item_recommend: SeatMapPassenger.item_recommend,
            item_withSeat: SeatMapPassenger.item_withSeat,
            avatar: SeatMapPassenger.avatar,
            passengerName: SeatMapPassenger.passengerName,
            payload: SeatMapPassenger.payload,
            select: SeatMapPassenger.select,
            numbers: SeatMapPassenger.numbers,
            money: SeatMapPassenger.money,
            clear: SeatMapPassenger.clear,
            freeSeat__text: SeatMapPassenger.freeSeatTtext
        },
        DoubleSeat: {
            container: SeatMapDoubleSeat.container,
            switch__label: SeatMapDoubleSeat.switch__label,
            description: SeatMapDoubleSeat.description
        },
        SeatMapDisclaimerStyles: {
            disclaimer: SeatMapDisclaimer.disclaimer
        },
        Controls: {
            controls: SeatMapControls.controls,
            back: SeatMapControls.back,
            button: SeatMapControls.button
        },
        SeatStyles: {
            seat: SeatMapSeat.seat,
            seat_business: SeatMapSeat.seat_business,
            seat_occupied: SeatMapSeat.seat_occupied,
            seat_unavailable: SeatMapSeat.seat_unavailable,
            seat_unexistent: SeatMapSeat.seat_unexistent,
            seat_recommend: SeatMapSeat.seat_recommend,
            seat_recommendCurrent: SeatMapSeat.seat_recommendCurrent,
            number: SeatMapSeat.number
        },
        SeatsInfoStyles: {
            seat: SeatMapSeatsInfo.seat,
            seat_business: SeatMapSeatsInfo.seat_business,
            title: SeatMapSeatsInfo.title,
            description: SeatMapSeatsInfo.description,
            seat__info: SeatMapSeatsInfo.seat__info,
            features: SeatMapSeatsInfo.features
        },
        SeatTooltipStyles: {
            tooltip: SeatMapTooltip.tooltip,
            tooltip_recommend: SeatMapTooltip.tooltip_recommend,
            tooltip_withInfo: SeatMapTooltip.tooltip_withInfo,
            info: SeatMapTooltip.info
        }
    },
    AdditionalServiceBanner: {
        AdditionalServiceBannerStyles: {
            baggageBanner: AdditionalServiceBanner.baggageBanner
        }
    },
    BaggagePage: {
        BaggagePage: {
            baggage: BaggagePage.baggage,
            newBaggage: BaggagePage.newBaggage,
            additionalBaggage: BaggagePage.additionalBaggage
        }
    },
    BaggageList: {
        BaggageList: {
            root: BaggageList.root,
            item: cn(BaggageList.item, Baggage.item),
            count: BaggageList.count,
            counts: BaggageList.counts
        },
        BaggageCount: {
            root: BaggageCount.root
        },
        BaggageDirection: {
            root: BaggageDirection.root
        }
    },
    Baggage: {
        Baggage: {
            root: Baggage.root,
            name: Baggage.name,
            size: Baggage.size
        },
        BaggageIcon: {
            carry_on: BaggageIcon.carry_on,
            large: BaggageIcon.large,
            real_size: BaggageIcon.real_size,
            size: BaggageIcon.size
        }
    },
    BaggageTotalPriceBlock: {
        BaggageTotalPriceBlock: {
            price: BaggagePage.price
        }
    },
    IncludedBaggage: {
        IncludedBaggage: {
            root: cn(BaggagePage.baggageCard),
            header: cn(BaggagePage.baggageHeader)
        }
    },
    AdditionalBaggage: {
        AdditionalBaggage: {
            root: cn(BaggagePage.baggageCard),
            header: cn(BaggagePage.baggageHeader)
        },
        PromoMessage: {
            root: AdditionalPromoMessage.root
        }
    },
    BaggageCard: {
        BaggageCard: {
            wrapper: cn(BaggagePage.baggageCard),
            price: cn(BaggagePage.price),
            selected: BaggageCard.selected,
            icon: BaggageCard.icon,
            title: BaggageCard.title,
            description: BaggageCard.description,
            header: BaggageCard.header
        }
    },
    OverweightBaggage: {
        OverweightBaggage: {
            flight_info: cn(BaggagePage.flight_info),
            flight_direction: cn(BaggagePage.flight_direction)
        }
    },
    SpecialEquipment: {
        SpecialEquipment: {
            flight_info: cn(BaggagePage.flight_info),
            flight_direction: cn(BaggagePage.flight_direction)
        }
    },
    UpgradeBaggageDialog: {
        UpgradeBaggageDialog: {
            modal__paper: UpgradeBaggageDialog.modal__paper,
            modalHeader: UpgradeBaggageDialog.modalHeader,
            close: UpgradeBaggageDialog.close,
            root: UpgradeBaggageDialog.root,
            body: UpgradeBaggageDialog.body
        },
        BaggageDialogHeader: {
            baggage_wrapper: BaggageDialogHeader.baggage_wrapper,
            description: BaggageDialogHeader.description,
            price_label: BaggageDialogHeader.price_label,
            label: BaggageDialogHeader.label
        },
        BaggagePassenger: {
            root: BaggagePassenger.root,
            number: BaggagePassenger.number,
            name: BaggagePassenger.name
        },
        BaggageSegment: {
            root: BaggageSegment.root
        },
        BaggageFooter: {
            root: BaggageFooter.root,
            row: BaggageFooter.row,
            price_wrapper: BaggageFooter.price_wrapper,
            price_block__delimiter: BaggageFooter.price_block__delimiter,
            clear: BaggageFooter.clear
        },
        HeaderEquipmentItem: {
            wrapper: HeaderEquipmentItem.wrapper
        }
    },
    BaggageCounter: {
        BaggageCounter: {
            minus: BaggageCounter.minus,
            plus: BaggageCounter.plus
        }
    },
    Counter: {
        Counter: {
            button: cn(Counter.button, BaggageCounter.button),
            button_disabled: Counter.button_disabled,
            value: Counter.value
        }
    },
    Switch: {
        SwitchV2: {
            main: SwitchV2.main,
            primary: SwitchV2.primary,
            active: SwitchV2.active
        }
    },
    MealService: {
        List: {
            item: MealServiceList.item,
            item_selected: MealServiceList.item_selected,
            item__icon: MealServiceList.item__icon
        }
    },
    Meal: {
        Meal: {
            meal: Meal.meal,
            name: Meal.name,
            count: Meal.count,
            price: Meal.price
        },
        Details: {
            content: MealDetails.content,
            row: MealDetails.row,
            name: MealDetails.name,
            trigger: MealDetails.trigger,
            trigger__icon: MealDetails.trigger__icon,
            description: MealDetails.description,
            counter: MealDetails.counter,
            passenger: MealDetails.passenger,
            passenger__index: MealDetails.passenger__index,
            total: MealDetails.total,
            totalText: MealDetails.totalText,
            clear: MealDetails.clear,
            footer: MealDetails.footer,
            selector: MealDetails.selector
        }
    },
    Button: {
        ActionButton: {
            button: ActionButton.button
        }
    },
    DesktopSummaryFlight: {
        SummaryFlight: {
            flight: DesktopSummaryFlight.flight
        }
    },
    Checkout: {
        CheckoutStyles: {
            checkout: Checkout.checkout,
            form: Checkout.form,
            checkoutServices: Checkout.checkoutServices,
            selectedFlight__container: Checkout.selectedFlight__container,
            container: Checkout.container,
            messages: Checkout.messages
        }
    },
    Contacts: {
        ContactsStyles: {
            contacts: Contacts.contacts,
            header: Contacts.header
        }
    },
    PassengerForm: {
        PassengerForm: {
            form: PassengerForm.form
        },
        Header: {
            header: PassengerFormHeader.header,
            filled: PassengerFormHeader.filled,
            number: PassengerFormHeader.number,
            passengerName: PassengerFormHeader.passengerName
        },
        Group: {
            container: cn(PassengerFormGroup.container, PassengerFormLoyaltyGroup.container),
            identity: cn(PassengerFormGroup.icon, PassengerFormGroup.identity),
            documents: cn(PassengerFormGroup.icon, PassengerFormGroup.documents),
            field_birthdate: PassengerFormGroup.field_birthdate
        },
        LoyaltyGroup: {
            container_loyalty: cn(PassengerFormGroup.icon, PassengerFormLoyaltyGroup.container_loyalty),
            toggle: PassengerFormLoyaltyGroup.toggle,
            loyalty_switch_open: PassengerFormLoyaltyGroup.loyaltySwitchOpen
        }
    },
    ServiceRecommendation: {
        Base: {
            button: ServiceRecommendation.button,
            button_cancel: ServiceRecommendation.button_cancel
        }
    },
    Passenger: {
        Switch: {
            element: PassengerSwitch.element,
            element_active: PassengerSwitch.element_active,
            element_error: PassengerSwitch.element_error,
            error: PassengerSwitch.error
        }
    },
    OrderCard: {
        OrderCard: {
            container: OrderCard.container,
            type_review: OrderCard.type_review
        },
        OrderPreview: {
            overlay: OrderPreview.overlay,
            inner: OrderPreview.inner,
            city: OrderPreview.city,
            main_city: OrderPreview.main_city,
            period: OrderPreview.period
        },
        CommonItem: {
            root: CommonItem.root,
            review: CommonItem.review,
            icon: CommonItem.icon
        },
        PaymentStatus: {
            root: PaymentStatus.root,
            icon: PaymentStatus.icon
        },
        OrderBooking: {
            root: OrderBooking.root,
            type_review: OrderBooking.type_review,
            orderCode: OrderBooking.orderCode,
            security_code: OrderBooking.security_code,
            price: OrderBooking.price,
            download: OrderBooking.download
        },
        OrderChange: {
            button: OrderChange.button
        }
    },
    Aeroexpress: {
        Aeroexpress: {
            modal: Aeroexpress.modal,
            modal__footer: Aeroexpress.modal__footer,
            modal__footerBtn: Aeroexpress.modal__footerBtn,
            modal_footer_btn_disabled: Aeroexpress.modal_footer_btn_disabled
        },
        ModalContent: {
            modal__title: AeroexpressModalContent.modal__title,
            modal__infoIcon: AeroexpressModalContent.modal__infoIcon,
            modal__conditions: AeroexpressModalContent.modal__conditions
        }
    },
    Service: {
        DialogStyles: {
            popupHeader: cn(Insurance.popupHeader)
        }
    },
    Insurance: {
        InsuranceStyles: {
            dialog: Insurance.dialog,
            wrapper: Insurance.wrapper,
            dialog__button_clear: Insurance.dialog__button_clear,
            dialog__button_done: Insurance.dialog__button_done,
            mobileWrapper: Insurance.mobileWrapper
        },
        InsuranceCardStyles: {
            insurance: InsuranceCard.insurance,
            selected: InsuranceCard.selected,
            insurance__header: InsuranceCard.insurance__header,
            insurance__money: InsuranceCard.insurance__money,
            option: InsuranceCard.option,
            insurance__button: InsuranceCard.insurance__button,
            insurance__button_selected: InsuranceCard.insurance__button_selected
        },
        MobileScreenStyles: {
            header: InsuranceCardMobileScreen.header
        }
    },
    VipServiceSelect: {
        VipServiceSelect: {
            header: cn(VipServiceSelect.header, CheckoutAdditionalServiceBusiness.dialogHeader),
            direction: VipServiceSelect.direction,
            switch__container: VipServiceSelect.switch__container,
            number: VipServiceSelect.number,
            passenger: VipServiceSelect.passenger,
            cancel: VipServiceSelect.cancel,
            confirm: VipServiceSelect.confirm
        }
    },
    SearchForm: {
        SearchForm: {
            searchForm: SearchForm.searchForm
        },
        Segments: {
            segments: SearchFormSegments.segments,
            segments_multiCity: SearchFormSegments.segments_multiCity
        },
        Segment: {
            cell: cn(SearchFormSegment.cell, SearchFormValue.cell),
            cell_date: SearchFormSegment.cell_date,
            cell_location: SearchFormSegment.cell_location,
            input: SearchFormSegment.input,
            input_text: SearchFormSegment.input_text,
            input_focused: SearchFormSegment.input_focused,
            alternative: SearchFormSegment.alternative
        },
        Location: {
            switcher: SearchFormLocation.switcher,
            switcher_highlighted: SearchFormLocation.switcher_highlighted,
            input: SearchFormLocation.input,
            input_icon: SearchFormLocation.input_icon,
            input_withoutPlaceholder: cn(SearchFormLocation.input_withoutPlaceholder, SearchFormSegment.input_withoutPlaceholder),
            switcher_alternative: SearchFormLocation.switcher_alternative
        },
        Value: {
            wrapper: SearchFormValue.wrapper,
            value: SearchFormValue.value,
            code: SearchFormValue.code,
            wrapper_alternative: SearchFormValue.wrapper_alternative
        },
        Datepicker: {
            dates: SearchFormDatepicker.dates,
            dates__to: SearchFormDatepicker.dates__to,
            dates__back: SearchFormDatepicker.dates__back,
            dates_focused: SearchFormDatepicker.dates_focused,
            dates__to_focused: SearchFormDatepicker.dates__to_focused,
            dates__back_focused: SearchFormDatepicker.dates__back_focused,
            dates__to_text: SearchFormDatepicker.dates__to_text,
            date__inputWrapper: SearchFormDatepicker.date__inputWrapper,
            placeholder: SearchFormDatepicker.placeholder,
            dow: SearchFormDatepicker.dow,
            alternative: SearchFormDatepicker.alternative,
            alternative_dow: SearchFormDatepicker.alternative_dow,
            highlighted_minPrice: SearchFormDatepicker.highlighted_minPrice,
            returnDelete: SearchFormDatepicker.returnDelete
        },
        Controls: {
            controls: SearchFormControls.controls,
            controls_multiCity: SearchFormControls.controls_multiCity
        },
        Passengers: {
            passengers: SearchFormPassengers.passengers,
            selector: SearchFormPassengers.selector,
            title: SearchFormPassengers.title,
            arrowIcon: SearchFormPassengers.arrowIcon,
            item: SearchFormPassengers.item,
            passengerType: SearchFormPassengers.passengerType,
            age: SearchFormPassengers.age,
            alternative: SearchFormPassengers.alternative,
            menu: SearchFormPassengers.menu,
            passengers_isMultiCity: SearchFormPassengers.passengers_isMultiCity
        },
        Currency: {
            currency: SearchFormCurrency.currency,
            selector: SearchFormCurrency.selector,
            arrowIcon: SearchFormCurrency.arrowIcon,
            item: SearchFormCurrency.item,
            dropdown: SearchFormCurrency.dropdown
        },
        StartSearch: {
            startSearch: SearchFormStartSearch.startSearch,
            startSearch_multiCity: SearchFormStartSearch.startSearch_multiCity
        },
        Bottom: {
            bottom: SearchFormBottom.bottom
        },
        MultiCity: {
            multiCity: SearchFormMultiCity.multiCity
        }
    },
    LocationAutocomplete: {
        Dropdown: {
            options: LocationDropdown.options,
            allDirections: LocationDropdown.allDirections,
            allDirections__button: LocationDropdown.allDirections__button
        },
        Group: {
            group: LocationGroup.group,
            group__label: LocationGroup.group__label
        },
        Option: {
            option: LocationOption.option,
            code: LocationOption.code
        },
        DirectionsDialog: {
            paper: DirectionsDialog.paper,
            dialog: DirectionsDialog.dialog,
            label: DirectionsDialog.label,
            countries: DirectionsDialog.countries,
            countries__list: DirectionsDialog.countries__list,
            country: DirectionsDialog.country,
            country_active: DirectionsDialog.country_active,
            cities: DirectionsDialog.cities,
            city: DirectionsDialog.city,
            iata: DirectionsDialog.iata
        }
    },
    SearchFormDatepicker: {
        MonthHeaderStyles: {
            monthHeader: SearchFormDatepickerMonthHeader.monthHeader,
            monthHeader__select_month: SearchFormDatepickerMonthHeader.monthHeader__select_month,
            monthHeader__select_year: SearchFormDatepickerMonthHeader.monthHeader__select_year
        },
        MonthsWrapperStyles: {
            nav_prev: SearchFormDatepickerMonthsWrapper.nav_prev,
            nav_next: SearchFormDatepickerMonthsWrapper.nav_next
        },
        WeeklyHeaderStyles: {
            dayOfWeekName_withPrices: SearchFormDatepickerWeeklyHeader.dayOfWeekName_withPrices
        },
        DayStyles: {
            day: SearchFormDatepickerDay.day,
            day_withPrice: SearchFormDatepickerDay.day_withPrice,
            day_selected: SearchFormDatepickerDay.day_selected,
            day__price: SearchFormDatepickerDay.day__price,
            day_today: SearchFormDatepickerDay.day_today,
            day_inPeriod: SearchFormDatepickerDay.day_inPeriod,
            day_hasPrice: SearchFormDatepickerDay.day_hasPrice,
            day_weekend: SearchFormDatepickerDay.day_weekend,
            day_startHover_withprice: SearchFormDatepickerDay.day_startHover_withprice,
            day_startHover_withPrice: SearchFormDatepickerDay.day_startHover_withPrice,
            day_endHover_withPrice: SearchFormDatepickerDay.day_endHover_withPrice,
            day_highlighted: SearchFormDatepickerDay.day_highlighted
        }
    },
    Results: {
        Results: {
            header: Results.header,
            inner: Results.inner,
            toolbar__backButton: Results.toolbar__backButton
        },
        Calendar: {
            legNumber: ResultsCalendar.legNumber,
            title__text: ResultsCalendar.title__text,
            title__cities: ResultsCalendar.title__cities
        },
        Sortings: {
            title: ResultsSortings.title,
            title_open: ResultsSortings.title_open,
            currentSorting: ResultsSortings.currentSorting,
            flightType: ResultsSortings.flightType,
            flightType__active: ResultsSortings.flightType__active,
            paper: ResultsSortings.paper
        },
        FlightsList: {
            controls__wrapper: ResultsFlightsList.controls__wrapper,
            leg: ResultsFlightsList.leg
        },
        MobilePriceGraph: {
            dates: ResultsMobilePriceGraph.dates
        }
    },
    QuickSearchForm: {
        QuickSearchForm: {
            inner: QuickSearchForm.inner,
            form: QuickSearchForm.form
        },
        Summary: {
            route: QuickSearchFormSummary.route,
            route__icon: QuickSearchFormSummary.route__icon,
            passengers: QuickSearchFormSummary.passengers
        }
    },
    Stepbar: {
        Step: {
            step: StepbarStep.step,
            step_active: StepbarStep.step_active
        }
    },
    WeekCalendar: {
        WeekCalendarStyles: {
            dayWrapper: cn(WeekCalendar.dayWrapper)
        },
        SliderStyles: {
            arrow_prev: WeekCalendarSlider.arrow_prev,
            arrow_next: WeekCalendarSlider.arrow_next
        },
        DayStyles: {
            day: WeekCalenderDay.day,
            day_selected: WeekCalenderDay.day_selected,
            day_notAvailable: WeekCalenderDay.day_notAvailable,
            day_best: WeekCalenderDay.day_best,
            date: WeekCalenderDay.date,
            date__dow: WeekCalenderDay.date__dow,
            date__info: WeekCalenderDay.date__info,
            price__wrapper: WeekCalenderDay.price__wrapper,
            price: WeekCalenderDay.price
        }
    },
    DesktopFlightRoute: {
        DesktopFlightRouteStyles: {
            flight: DesktopFlightRoute.flight,
            selected: DesktopFlightRoute.selected
        },
        SegmentStyles: {
            flightInfo__date: DesktopFlightRouteSegment.flightInfo__date,
            flightInfo__airline: DesktopFlightRouteSegment.flightInfo__airline,
            aircraft: DesktopFlightRouteSegment.aircraft,
            segment: DesktopFlightRouteSegment.segment,
            segment_additional: DesktopFlightRouteSegment.segment_additional,
            totalDuration__decorator: DesktopFlightRouteSegment.totalDuration__decorator,
            flightInfo__nextDay: DesktopFlightRouteSegment.flightInfo__nextDay
        },
        PointStyles: {
            time: DesktopFlightRoutePoint.time,
            airport: DesktopFlightRoutePoint.airport,
            point_thin: DesktopFlightRoutePoint.point_thin
        },
        RouteArrowStyles: {
            timeInRoute: DesktopFlightRouteArrow.timeInRoute,
            flightNumber: DesktopFlightRouteArrow.flightNumber
        },
        FlightPriceStyles: {
            price: DesktopFlightRoutePrice.price,
            button: DesktopFlightRoutePrice.button
        },
        StopsInfoStyles: {
            stop: DesktopFlightRouteStopsInfo.stop
        }
    },
    MobileFlight: {
        FlightStyles: {
            price: MobileFlight.price
        }
    },
    Passengers: {
        PassengerStyles: {
            decrease: PassengersPassenger.decrease,
            increase: PassengersPassenger.increase,
            counter: PassengersPassenger.counter,
            counter_disabled: PassengersPassenger.counter_disabled,
            passengerType: PassengersPassenger.passengerType,
            age: PassengersPassenger.age
        }
    },
    DesktopFlight: {
        DesktopFlightModalHeader: {
            container: DesktopFlightHeader.container,
            title: DesktopFlightHeader.title
        },
        ModalContent: {
            fareGroup__button: DesktopFlightModalContent.fareGroup__button,
            compareFaresLink: DesktopFlightModalContent.compareFaresLink,
            compareFaresLink_icon: DesktopFlightModalContent.compareFaresLink_icon,
            scroll_up: DesktopFlightModalContent.scroll_up,
            pagination__index: DesktopFlightModalContent.pagination__index,
            paper: DesktopFlightModalContent.paper,
            pagination: DesktopFlightModalContent.pagination,
            content_wrapper: DesktopFlightModalContent.content_wrapper,
            slider__wrp: DesktopFlightModalContent.slider__wrp
        },
        Location: {
            time: DesktopFlightLocation.time,
            date: DesktopFlightLocation.date,
            date_icon: DesktopFlightLocation.date_icon,
            city: DesktopFlightLocation.city,
            terminal: DesktopFlightLocation.terminal,
            time_iata: DesktopFlightLocation.time_iata,
            isMobile: DesktopFlightLocation.isMobile
        },
        DesktopFlightModalContentSelected: {},
        SelectedFareGroup: {
            fare: cn(DesktopFlightSelectedFare.fare, FareGroup.selected),
            button: DesktopFlightSelectedFare.button
        },
        FlightInfoSegment: {
            card: DesktopFlightFlightInfoSegment.card,
            isMobile: DesktopFlightFlightInfoSegment.isMobile
        }
    },
    FareGroup: {
        FareGroup: {
            fareGroup_white: FareGroup.fareGroup_white,
            fareGroup_recommended: FareGroup.fareGroup_recommended,
            option: FareGroup.option,
            option_unavailable: FareGroup.option_unavailable,
            option__title: FareGroup.option__title,
            option__value: FareGroup.option__value,
            options: FareGroup.options,
            button: FareGroup.button,
            keyFeature: FareGroup.keyFeature
        },
        FareGroupGrid: {
            header: FareGroupGrid.header,
            option: FareGroupGrid.option,
            small: FareGroupGrid.small,
            paid: FareGroupGrid.paid
        },
        FareGroupIcon: {
            container: FareGroupIcon.container
        }
    },
    FlightCard: {
        FlightCard: {
            airline__name: FlightCard.airline__name,
            airline__number: FlightCard.airline__number,
            aircraft__name: FlightCard.aircraft__name,
            flight: FlightCard.flight
        }
    },
    FareLock: {
        FareLock: {
            root: FareLock.root
        },
        DescriptionBlock: {
            root: FareLockDescriptionBlock.root,
            icon: FareLockDescriptionBlock.icon,
            title: FareLockDescriptionBlock.title,
            description: FareLockDescriptionBlock.description
        },
        SwitchBlock: {
            root: FareLockSwitchBlock.root,
            switch_wrapper: FareLockSwitchBlock.switch_wrapper,
            switch_label: FareLockSwitchBlock.switch_label,
            switch_control: FareLockSwitchBlock.switch_control,
            switch_active: FareLockSwitchBlock.switch_active,
            price_wrapper: FareLockSwitchBlock.price_wrapper,
            price_label: FareLockSwitchBlock.price_label,
            price: FareLockSwitchBlock.price
        }
    },
    Toolbar: {
        Toolbar: {
            toolbar: Toolbar.toolbar,
            button: Toolbar.button,
            price: Toolbar.price
        }
    },
    Datepicker: {
        DayStyles: {
            day_notAvailable: DatepickerDay.day_notAvailable
        }
    },
    Amenities: {
        Amenities: {
            amenities__item: Amenities.amenities__item
        }
    },
    Link: {
        Link: {
            link: Link.link
        }
    },
    PassengersDetails: {
        PassengersDetails: {
            close: PassengersDetails.close,
            number: PassengersDetails.number
        }
    },
    Checkin: {
        Passengers: {
            toolbar: Checkin.passengers__toolbar,
            toolbar__button: Checkin.passengers__toolbarButton
        }
    },
    PromoLoader: {
        PromoLoader: {
            promo__image: PromoLoader.promo__image,
            promo: PromoLoader.promo__wrapper
        }
    },
    Refund: {
        StepsButtons: {
            backButton: StepsButtons.backButton
        },
        Ticket: {
            reject: Ticket.reject
        }
    },
    PaymentForm: {
        PaymentForm: {
            cards_header: PaymentForm.cards_header
        }
    },
    PriceGraph: {
        PriceGraphStyles: {
            graphHeader: PriceGraph.graphHeader,
            calendar_longPrice: PriceGraph.calendar_longPrice,
            graphHeader_longPrice: PriceGraph.graphHeader_longPrice
        }
    },
    CompareFares: {
        CompareFares: {
            fareHeadingItem__serviceClass: CompareFares.fareHeadingItem__serviceClass
        }
    },
    Pagination: {
        Pagination: {
            item_active: Pagination.item_active,
            item: Pagination.item
        }
    }
};
export default theme;
